// react
import { useEffect } from "react";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showAppModal } from "~/redux/actions/app";
import {
  getPostComments,
  resetComments,
  deleteComment,
  checkCommentFlags,
  GET_POST_COMMENTS,
} from "~/redux/actions/comment";

// views
import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import CommentItem from "~/components/comment/CommentItem";
import EmptyList from "~/components/app/EmptyList";

// utils
import _ from "lodash";
import { hasAnyRole } from "~/utils/user";

const CommentList = (props) => {
  // props
  const { commentSsr, commentList, request } = props;
  const loading = request[GET_POST_COMMENTS];
  let comments = [];
  let nextPage = 0;
  if (props.token) {
    comments = _.get(commentList, "comments") || [];
    nextPage = _.get(commentList, "pager.next_page");
  } else {
    comments = _.get(commentSsr, "comments") || [];
    nextPage = _.get(commentSsr, "pager.next_page");
  }

  const handleDelete = (comment, reason, templateId) => {
    props.deleteComment(props.token, comment, {
      reason,
      reason_template_id: templateId,
    });
  };
  const handleLoadMore = () => {
    if (props.token) {
      props.getPostComments(props.post.id, {
        page: nextPage,
        sort: props.sort,
      });
    } else {
      props.showAppModal("PhoneSigninModal");
    }
  };
  const handleFetched = () => {
    const { name, data } = props.event;
    if (props.token && name === GET_POST_COMMENTS) {
      props.checkCommentFlags(props.token, ["voted"], data);
    }
  };
  const checkOwner = (comment) => {
    return props.user && props.user.id === comment.user.id;
  };
  const checkCollaboration = () => {
    return (
      props.collaboration && !hasAnyRole(props.user, ["paid_category_follower"])
    );
  };

  // const checkAuthor = (comment) => {
  //   return props.post && (props.post.user.id === comment.user.id)
  // }

  const checkAuthor = (user) => {
    return props.post && props.post.user.id === user.id;
  };

  // views
  const renderPager = nextPage && !loading && (
    <div className="text-center my-20">
      <Button
        size="small"
        onClick={handleLoadMore}
      >
        加载更多
      </Button>
    </div>
  );
  const renderLoader = (loading || (!commentList && !commentSsr)) && (
    <div className="text-center my-20">
      <Button
        size="small"
        icon={<LoadingOutlined />}
        disabled
      >
        加载中
      </Button>
    </div>
  );

  // events
  useEffect(() => {
    props.resetComments();
    //change sort get comment
    //props.getPostComments(props.post.id, { page: 1 , sort: props.sort})
  }, [props.post.id]);

  useEffect(() => handleFetched(), [props.event]);

  useEffect(() => {
    if (props.token) {
      props.getPostComments(props.post.id, { page: 1, sort: props.sort });
    }
  }, [props.sort]);

  return (
    <div>
      <div className="comment-list">
        {(commentList || commentSsr) &&
          (comments.length ? (
            comments.map((comment) => (
              <CommentItem
                comment={comment}
                key={comment.id}
                checkOwner={checkOwner}
                checkAuthor={checkAuthor}
                checkCollaboration={checkCollaboration}
                onDelete={handleDelete}
              />
            ))
          ) : (
            <EmptyList />
          ))}
      </div>

      {renderPager}
      {renderLoader}
    </div>
  );
};

const mapStateToProps = (state) => ({
  event: state.app.event,
  token: state.user.token,
  user: state.user.user,
  commentList: state.comment.commentList,
  request: state.app.request,
  collaboration: state.app.collaboration,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPostComments,
      resetComments,
      deleteComment,
      checkCommentFlags,
      showAppModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CommentList);
